export default __webpack_public_path__ + "static/media/frenchIcon.379f09c5.svg";